document.addEventListener("DOMContentLoaded", function() {

    // Tabby inicializace
    // ==================
    if (typeof Tabby === 'undefined')
        return;

    (function () {
        let tabsEl = document.querySelectorAll('[data-tabs] li');
        if (tabsEl.length === 0)
            return;

        // pro nemovitosti v levem menu ve statech
        let tabs2 = document.querySelector('.JS-responsiveTabs-2');
        if(typeof(tabs2) !== 'undefined' && tabs2 !== null && tabs2.getAttribute('data-active') && tabs2.querySelectorAll('ul li').length > 1)
            tabs2.querySelectorAll('ul li')[1].querySelector('a').setAttribute('data-tabby-default', '');

        // pokud není nastavena defaultní záložka
        let defaultTabs = document.querySelectorAll('[data-tabs] [data-tabby-default]');
        if (defaultTabs.length === 0)
            tabsEl[0].querySelector('a').setAttribute('data-tabby-default', '');

        let tabs = new Tabby('[data-tabs]');

        // resize mapy
        let mapTabs = document.querySelector('[data-tabs]').querySelectorAll('a[href="#mapa"], a[href="#projekty2-mapa"]');
        if(!mapTabs.length)
            return;

        const resizeMap = () => {

            let map = document.querySelector('.GoogleMap');
            if (typeof map === 'undefined' || map === null) {
                return;
            }

            if (!map.dataStorage || !map.dataStorage.map) {
                return;
            }

            let gmMap = map.dataStorage.map,
                zoom = map.dataStorage.zoom;

            if (typeof gmMap === 'undefined')
                return;

            window.google.maps.event.trigger(gmMap, 'resize');
            let bounds = map.dataStorage.bounds;

            if (map.dataStorage.markers) {
                map.dataStorage.markers.forEach((el) => {
                    bounds.extend(el.getPosition());
                });
            }
            if (map.dataStorage.polygons) {
                map.dataStorage.polygons.forEach((polygon) => {
                    polygon.getPath().forEach((latlng) => {
                        bounds.extend(latlng);
                    })
                });
            }

            gmMap.fitBounds(bounds);

            if (zoom)
                gmMap.setZoom(zoom);
        }

        mapTabs.forEach((tab) => {
            tab.addEventListener('click', resizeMap);
        });
    }());
});